import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { createBrowserHistory } from 'history'
const Auth0ProviderWithHistory = ({ children }) => {
	const domain = process.env.REACT_APP_AUTH0_DOMAIN
	const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
	const audience = process.env.REACT_APP_AUTH0_AUDIENCE

	let history = createBrowserHistory()

	const onRedirectCallback = appState => {
		history.push(appState?.returnTo || window.location.pathname)
	}

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			redirectUri={window.location.origin}
			onRedirectCallback={onRedirectCallback}
			audience={audience}
		>
			{children}
		</Auth0Provider>
	)
}

export default Auth0ProviderWithHistory
